/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Import_As_EventsInputs */

const en_ocr_import_as_events = /** @type {(inputs: Ocr_Import_As_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import as Event Group`)
};

const fr_ocr_import_as_events = /** @type {(inputs: Ocr_Import_As_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer en tant que groupe d'événements`)
};

const de_ocr_import_as_events = /** @type {(inputs: Ocr_Import_As_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Ereignisgruppe importieren`)
};

const it_ocr_import_as_events = /** @type {(inputs: Ocr_Import_As_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa come gruppo di eventi`)
};

const ru_ocr_import_as_events = /** @type {(inputs: Ocr_Import_As_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импортировать как группу событий`)
};

const es_ocr_import_as_events = /** @type {(inputs: Ocr_Import_As_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar como grupo de eventos`)
};

const zh_cn2_ocr_import_as_events = /** @type {(inputs: Ocr_Import_As_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入为事件组`)
};

const ja_ocr_import_as_events = /** @type {(inputs: Ocr_Import_As_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループとしてインポート`)
};

const hi_ocr_import_as_events = /** @type {(inputs: Ocr_Import_As_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह के रूप में आयात करें`)
};

const pt_pt2_ocr_import_as_events = /** @type {(inputs: Ocr_Import_As_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar como Grupo de Eventos`)
};

/**
* | output |
* | --- |
* | "Import as Event Group" |
*
* @param {Ocr_Import_As_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_import_as_events = /** @type {((inputs?: Ocr_Import_As_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Import_As_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_import_as_events(inputs)
	if (locale === "de") return de_ocr_import_as_events(inputs)
	if (locale === "it") return it_ocr_import_as_events(inputs)
	if (locale === "ru") return ru_ocr_import_as_events(inputs)
	if (locale === "es") return es_ocr_import_as_events(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_import_as_events(inputs)
	if (locale === "ja") return ja_ocr_import_as_events(inputs)
	if (locale === "hi") return hi_ocr_import_as_events(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_import_as_events(inputs)
	return en_ocr_import_as_events(inputs)
});